import useAppVariant from "features/common/hooks/useAppVariant";

export default function useShowEmailFieldByVariant() {
  const appVariant = useAppVariant();

  const valuesByVariant = {
    seneca: true,
    senecaPrimary: true,
    plurall: false,
    goStudentLearning: false
  };

  return valuesByVariant[appVariant];
}
